<app-bread-crumb [items]="[{text:  'produtos',link:'/admin/products'},{text:'detalhe'}]"
  [sectionTitle]="'Detalhe'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-4">
      <!-- Profile Image -->
      <div class="box box-success" style="border-top: 2px solid #f35309;">

        <div class="box-body box-profile">

          <img 
            class="img-responsive" 
            style="width:185px ;height:185px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;" 
            [src]="product.image || 'http://localhost:4200/assets/Khuzela.png'"
            alt="imagem do parceiro">

          <ul class="list-group list-group-unbordered" style="margin-top: 10px;">

            <li class="list-group-item">

              <div class="upload-btn-wrapper">

                <button class="btn btn-outline-danger btn-block">
                  <i class="fa fa-cloud-upload"></i> Clique aqui para actualizar a Imagem
                </button>
    
                <input title="" type="file" #iptFile (input)="updateImageProfile($event,product)"/>

              </div>

            </li>

          </ul>

        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </div>


    <div class="col-md-8">

      <div class="box box-widget widget-user-2" style="border-top: 2px solid #f35309;">

        <div class="box-footer no-padding">
          <ul class="nav nav-stacked">
            <li><a href="javascript:void(0);"><strong>Código</strong> <span class="pull-right">{{product?.product_code}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Título</strong> <span class="pull-right">{{product?.title}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Descrição</strong> <span class="pull-right">{{product?.description}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Categoria</strong> <span class="pull-right">{{product?.category}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Subcategoria</strong> <span class="pull-right">{{product?.subcategory}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Clube</strong> <span class="pull-right" [ngStyle]="{color: product?.clubColor,padding:'2px'}"><strong>{{product?.clubName || 'Sem clube definido'}}</strong></span></a></li>
            <li class="botao">
              <button type="button" (click)="editProduct(product)" class="btn btn-outline-danger pull-right"><strong><i
                    class="fa fa-edit"></i> Editar</strong></button>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </div>

</section>